import { render } from "./TopoBackground.vue?vue&type=template&id=07844816"
import script from "./TopoBackground.vue?vue&type=script&lang=js"
export * from "./TopoBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__